import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { AppApi, EDITOR_TYPE, PageType } from '@wix/wix-data-client-common'
import {
  getRouterDatasetDefinition,
  isClassicEditor,
} from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

export const addRouterDataset = async ({
  editorSdkProxy,
  appApi,
  editorType,
  pageRef,
  collectionName,
  pageType,
}: {
  editorSdkProxy: EditorSDK
  appApi: AppApi
  editorType: EDITOR_TYPE
  pageRef: PageRef
  collectionName: string
  pageType: PageType
}) => {
  const navigateToPage = () => editorSdkProxy.pages.navigateTo({ pageRef })

  const addDataset = async () => {
    await editorSdkProxy.components.add({
      pageRef,
      componentDefinition: getRouterDatasetDefinition({
        collectionName,
        pageType,
        editorType,
      }),
    })
    await appApi.emit('datasetAdded')
  }

  if (isClassicEditor(editorType)) {
    await addDataset()
    await navigateToPage()
  } else {
    await navigateToPage()
    await addDataset()
  }
}
